import api from '@/utils/api';

export interface AiChatMessage {
  role: 'user' | 'assistant';
  content: string;
}

export interface AiSqlQuery {
  sql: string;
  rows?: number;
  error?: string;
}

export interface AiChatResult {
  reply: string;
  sql_queries: AiSqlQuery[];
  stop_reason: string;
}

export const sendAiChat = async (messages: AiChatMessage[]) => {
  return api.post<AiChatResult>('/ai/chat', { messages });
};
